import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid2 } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { getYear } from 'utils/DateUtil'
import { P105_3, VP_059, VP_060, VP_061, VP_063, VP_077, VP_201, VP_228, VP_232 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity } from 'rpqs/utils/RPQSUtils'
import { round } from 'lodash'

const DialogP105_3 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        managementEntity,
    } = useSelector(store => ({
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntityDialog] = useState(managementEntity)

    useEffect(() => {
        setEntityDialog(managementEntity)
    }, [managementEntity])

    const year = getYear(entityDialog?.dateEnd)
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const formatedIndicators = [
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_077.code,
            indicatorName: i18n[VP_077.i18n],
            unit: 'km',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_077.code,
                { ...currentEntity?.[VP_077.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_059.code,
            indicatorName: i18n[VP_059.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_059.code,
                { ...currentEntity?.[VP_059.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_060.code,
            indicatorName: i18n[VP_060.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_060.code,
                { ...currentEntity?.[VP_060.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_061.code,
            indicatorName: i18n[VP_061.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_061.code,
                { ...currentEntity?.[VP_061.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_063.code,
            indicatorName: i18n[VP_063.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_063.code,
                { ...currentEntity?.[VP_063.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_201.code,
            indicatorName: i18n[VP_201.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_201.code,
                { ...currentEntity?.[VP_201.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_232.code,
            indicatorName: i18n[VP_232.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_232.code,
                { ...currentEntity?.[VP_232.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_228.code,
            indicatorName: i18n[VP_228.i18n],
            unit: 'ab/km',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_228.code,
                { ...currentEntity?.[VP_228.code], value: parseInt(v) || 0 },
            ))),
        }),

    ]

    const onStatusChange = (status) => {
        setEntityDialog(updateIndicatorEntity(entityDialog, year, P105_3.code, { ...currentEntity?.[P105_3.code], status }))
    }

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator?.code]?.value || 0)

    const calculation = () => {
        const calculatedValue = getIndicatorValue(VP_077) > 0 ? round((getIndicatorValue(VP_059) + getIndicatorValue(VP_060) - getIndicatorValue(VP_061) - getIndicatorValue(VP_232)) / getIndicatorValue(VP_077) / 365, 2) : 0

        return updateIndicatorEntity(entityDialog, year, P105_3.code, { ...currentEntity?.[P105_3.code], value: calculatedValue })
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntityDialog}
            codeIndicator={P105_3.code}
            calculationOnRegister={calculation}
        >
            <Grid2 container direction={'column'} gap={2}>
                <IndicatorHeaderDialog
                    current={{
                        year,
                        value: managementEntity?.[year]?.[P105_3.code]?.value,
                    }}
                    previous={{
                        year: previousYear,
                        value: managementEntity?.[previousYear]?.[P105_3.code]?.value,
                    }}
                    status={entityDialog?.[year]?.[P105_3.code]?.status}
                    onStatusChange={onStatusChange}
                    unit={i18n.m3KmD}
                />
                <Divider/>
                <IndicatorTable
                    year={year?.toString()}
                    indicators={formatedIndicators}
                />

            </Grid2>
        </EntityIndicatorDialog>
    )
}

DialogP105_3.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP105_3
